import { configureStore } from "@reduxjs/toolkit";
import codingReducer from "./coding";
import logoReducer from "./logo";
import userReducer from "./user";

export const store = configureStore({
  reducer: {
    coding: codingReducer,
    user: userReducer,
    logo: logoReducer
  }
});
